import { Component, OnInit, input, output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-whitelabel-android-credentials-upload',
  templateUrl: './whitelabel-android-credentials-upload.component.html',
  styleUrls: ['./whitelabel-android-credentials-upload.component.css']
})
export class WhitelabelAndroidCredentialsUploadComponent implements OnInit {

  readonly type = input.required<'keytool' | 'store'>();

  public readonly errorEvent$ = output<void>();

  public readonly successEvent$ = output<File>();

  ngOnInit(): void {
  }

  public onKeytoolUpload(event: any) {
    const files = event.target.files;
    const uploadedFile = files[0];

    if (uploadedFile) {
      if (uploadedFile.name !== 'keytool') {
        this.errorEvent$.emit();
        return;
      }

      this.successEvent$.emit(uploadedFile);
      return;
    }
  }

  public onStoreUpload(event: any) {
    const files = event.target.files;
    const uploadedFile = files[0];

    if (uploadedFile) {
      if (uploadedFile.name !== 'store') {
        this.errorEvent$.emit();
        return;
      }

      this.successEvent$.emit(uploadedFile);
      return;
    }
  }
}
